import type { FC } from 'react';
import { memo } from 'react';
import { Box, Skeleton } from '@mui/material';
import Masonry from '@mui/lab/Masonry';
import getSkeletonArray from '../../../utils/getSkeletonArray';
import useInitMasonryColumns from '../../../hooks/useInitMasonryColumns';

const CreativesViewSkeleton: FC = memo(() => {
  const { columns } = useInitMasonryColumns();
  const arr = getSkeletonArray(10);

  return (
    <Box sx={{ display: 'flex', width: 'calc(100% + 30px)', mx: '-15px' }}>
      <Masonry columns={columns} spacing={2} sx={{ '&': { m: 0 } }}>
        {arr.map(({ id }) => (
          <Box
            key={`creative-${id}-paper-skeleton`}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              justifyContent: 'start',
              p: 1,
              gap: 0.75,
            }}
          >
            <Skeleton
              width={'100%'}
              height={Math.floor(Math.random() * (300 - 100 + 1)) + 100}
              sx={{ transform: 'none', m: 0, p: 0 }}
            />
          </Box>
        ))}
      </Masonry>
    </Box>
  );
});

CreativesViewSkeleton.displayName = 'CreativesViewSkeleton';

export default CreativesViewSkeleton;
